import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const AddressModal = ({ 
  addressForm, 
  setAddressForm, 
  cities, 
  handleSaveAddress, 
  setIsAddressModalOpen, 
  addressSubmitting 
}) => {
  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden animate-in fade-in zoom-in duration-200">
        <div className="flex items-center justify-between p-6 border-b border-gray-100">
          <h3 className="text-2xl font-tajawal font-bold text-brand-black">
            {addressForm.id ? 'تعديل العنوان' : 'إضافة عنوان جديد'}
          </h3>
          <button onClick={() => setIsAddressModalOpen(false)} className="text-gray-400 hover:text-red-500 transition-colors p-2 bg-gray-50 rounded-full">
            <X className="w-5 h-5" />
          </button>
        </div>
        
        <form onSubmit={handleSaveAddress} className="p-6 space-y-5">
          <div>
            <Label className="font-cairo font-bold text-gray-700">المحافظة <span className="text-red-500">*</span></Label>
            <select
              name="city_id"
              value={addressForm.city_id}
              onChange={(e) => setAddressForm({...addressForm, city_id: e.target.value})}
              required
              className="mt-1 flex h-12 w-full rounded-xl border border-gray-200 bg-gray-50 px-3 py-2 text-md font-cairo focus:border-burgundy-500 focus:ring-1 focus:ring-burgundy-500 outline-none transition-all"
            >
              <option value="">اختر المحافظة...</option>
              {cities.map((city) => (
                <option key={city.id} value={city.id}>{city.name}</option>
              ))}
            </select>
          </div>

          <div>
            <Label className="font-cairo font-bold text-gray-700">الشارع والحي <span className="text-red-500">*</span></Label>
            <Input
              name="street"
              value={addressForm.street}
              onChange={(e) => setAddressForm({...addressForm, street: e.target.value})}
              placeholder="مثال: شارع الملك عبدالله، حي الملقا"
              required
              className="mt-1 h-12 rounded-xl bg-gray-50 border-gray-200 focus:border-burgundy-500 focus:ring-1 focus:ring-burgundy-500"
            />
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label className="font-cairo font-bold text-gray-700">المبنى / رقم المنزل</Label>
              <Input
                name="building"
                value={addressForm.building}
                onChange={(e) => setAddressForm({...addressForm, building: e.target.value})}
                placeholder="اختياري"
                className="mt-1 h-12 rounded-xl bg-gray-50 border-gray-200 focus:border-burgundy-500 focus:ring-1 focus:ring-burgundy-500"
              />
            </div>
            <div>
              <Label className="font-cairo font-bold text-gray-700">رقم الهاتف</Label>
              <Input
                name="phone"
                value={addressForm.phone}
                onChange={(e) => setAddressForm({...addressForm, phone: e.target.value})}
                placeholder="اختياري"
                className="mt-1 h-12 rounded-xl bg-gray-50 border-gray-200 focus:border-burgundy-500 focus:ring-1 focus:ring-burgundy-500 text-left"
                dir="ltr"
              />
            </div>
          </div>
          
          <div>
            <Label className="font-cairo font-bold text-gray-700">تفاصيل إضافية للعنوان</Label>
            <Input
              name="details"
              value={addressForm.details}
              onChange={(e) => setAddressForm({...addressForm, details: e.target.value})}
              placeholder="مثال: بجوار مسجد النور، الطابق الثاني"
              className="mt-1 h-12 rounded-xl bg-gray-50 border-gray-200 focus:border-burgundy-500 focus:ring-1 focus:ring-burgundy-500"
            />
          </div>

          {!addressForm.is_default && (
            <label className="flex items-center gap-3 cursor-pointer p-4 border border-gray-200 rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors">
              <input
                type="checkbox"
                checked={addressForm.is_default}
                onChange={(e) => setAddressForm({...addressForm, is_default: e.target.checked})}
                className="w-5 h-5 accent-burgundy-500"
              />
              <span className="font-cairo font-bold text-gray-700">تعيين هذا العنوان كعنوان افتراضي</span>
            </label>
          )}

          <div className="flex gap-3 pt-4 border-t border-gray-100">
            <Button
              type="button"
              variant="outline"
              onClick={() => setIsAddressModalOpen(false)}
              className="flex-1 h-12 rounded-xl font-cairo font-bold text-gray-600 hover:bg-gray-100 border-gray-200"
            >
              إلغاء
            </Button>
            <Button
              type="submit"
              disabled={addressSubmitting}
              className="flex-1 h-12 rounded-xl font-cairo font-bold bg-burgundy-500 hover:bg-burgundy-600 text-white shadow-md shadow-burgundy-500/20"
            >
              {addressSubmitting ? 'جاري الحفظ...' : 'حفظ العنوان'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddressModal;
